import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/axios.js";

const Login = () => {
    const [empId, setEmpId] = useState('');
    const navigate = useNavigate();
    const canSubmit = empId.trim();
    const idCheck = async (event) => {
        event.preventDefault();

        try {
            const res = await api.get("/auth/first-login", {
                params: { employeeId: empId },
            });
            
            const { role, firstLogin } = res.data;
            if(role === "manager"){
                navigate("/password", {state: { empId, role} });
            }else if(firstLogin === true){
                navigate("/first-login", {state: {empId, role}});
            }else{
                navigate("/password", {state: {empId, role}});
            }
        } catch (err) {
            console.error(err);
            let message = "Request failed";
            if (err.response && err.response.data && err.response.data.message) {
                message = err.response.data.message;
            }
            alert(message);
        }
    };

    return (
        <>
            <div className="logo">
                <img src="/images/logo-circle-dark.png" alt="logo" className="circle"/>
                <img src="/images/brevia-brown.png" className="brevia"></img>
            </div>
            <div className="logo-wrapper">
                <div className="login-wrapper">
                    <h2>Welcome to Brevia</h2>
                    <form onSubmit={idCheck} className="emp_form">
                        <label htmlFor="employee-id">
                            Employee ID
                        </label>
                        <div className="input_wrapper">
                            <input
                                type="text"
                                placeholder="Enter your Employee ID"
                                value={empId}
                                onChange={(e) => setEmpId(e.target.value)}
                                required
                            />
                        </div>
                        <button type="submit" className="submit" disabled={!canSubmit}>Submit</button>
                    </form>
                </div>
            </div>
        </>
    )
}

export default Login;